'use strict';
(function () {
  angular.module('pentaApp').factory('clubLevel.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/clubLevel');
  }
})();
